class ResourceListDirective
  @$inject: ["$rootScope", "$injector", "$timeout", "$stateParams", "$q"]
  constructor: ($rootScope, $injector, $timeout, $stateParams, $q)->                
    class ResourceList
      require: "restfulResources"
      link: ($scope, $element, $attrs, controller)->   
        controller.options.folder = ""
        $scope = $scope.$parent
        @locations = []
        
        $scope.$watch "current", (val)=>          
          current = ""
          if val
            current = val._id          
          if controller.options.folder isnt current
            controller.options.folder = current
            controller.options.search = null
            controller.query()
          

        controller.go = (folder)=>          
          @locations.push $scope.current
          if folder?.type is "FOLDER"            
            $scope.current = folder
        
        controller.back = ()=>          
          previous = @locations.pop()
          $scope.current = previous


        controller.search = (term)=>
          if term
            controller.options.folder = null
            controller.options = 
              search: term
            controller.query(term)
          else
            if $scope.current
              controller.options.folder = $scope.current._id              
            else
              controller.options.folder = ""
            controller.refresh()



    return new ResourceList()

  
module.exports = ResourceListDirective


// WEBPACK FOOTER //
// ./src/component/resource/list.coffee